import fetch from 'cross-fetch';
import type { IncomingMessage } from 'http';
import type { IntlShape } from 'react-intl';

import { SSR_MODE } from '@/lib/const';
import { TIME_SLOT } from '@/lib/metadata/const';
import { paths } from '@/lib/paths';
import * as M from '@/views/DeliveryView/messages';

export const generatePayPerLinkToken = async (
  id: string,
  req?: IncomingMessage,
): Promise<string> => {
  let origin = '';

  if (SSR_MODE) {
    if (!req) {
      throw new Error('Request must be passed when used on the server');
    }

    /**
     * When moved to Vercel use `VERCEL_URL` variable
     * https://vercel.com/docs/projects/environment-variables/system-environment-variables
     * On the client we don't need to pass the origin.
     */
    if (req.headers?.referer) {
      origin = new URL(req.headers.referer).origin;
    } else {
      const _protocol = req.headers['x-forwarded-proto'];
      const protocol = _protocol && (_protocol as string).split(',')[0];
      origin = `${protocol || 'https'}://${req.headers['x-forwarded-host']}`;
    }
  }

  const result = await fetch(
    `${origin}${paths.api.order.tokenCreate.asPath({ id })}`,
    {
      method: 'POST',
    },
  );

  if (!result.ok) {
    throw new Error('Could not generate pay per order token.');
  }
  const json = await result.json();
  return json.payPerLinkToken;
};

export const transformTimeSlot = (
  formatMessage: IntlShape['formatMessage'],
  timeSlot?: string | null,
) => {
  const timeSlotMap: Record<string, string> = {
    [TIME_SLOT.BEFORE_9]: formatMessage(M.TimeSlotLabelMessages.before9),
    [TIME_SLOT.BETWEEN_9_AND_12]: formatMessage(
      M.TimeSlotLabelMessages.between9And12,
    ),
    [TIME_SLOT.BETWEEN_11_AND_14]: formatMessage(
      M.TimeSlotLabelMessages.between11And14,
    ),
    [TIME_SLOT.BETWEEN_17_AND_20]: formatMessage(
      M.TimeSlotLabelMessages.between17And20,
    ),
  };
  if (typeof timeSlot === 'string') {
    return timeSlotMap[timeSlot] || timeSlot;
  }
  return timeSlot;
};
